import { render, staticRenderFns } from "./validation-handler.vue?vue&type=template&id=e9efac78&scoped=true"
import script from "./validation-handler.vue?vue&type=script&lang=js"
export * from "./validation-handler.vue?vue&type=script&lang=js"
import style0 from "./validation-handler.vue?vue&type=style&index=0&id=e9efac78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9efac78",
  null
  
)

export default component.exports